import React, { useEffect, useState } from 'react';
import InnerHTML from 'dangerously-set-html-content'

import _ from 'lodash';
import cx from 'classnames';
import styles from './html.module.scss';


const HtmlWidgetComponent = ({ className, style, widgetProps, content }) => {
  const id = _.get(widgetProps, 'uid');
  const iframe = _.get(widgetProps, 'properties.desktop.iframe', false);

  var widgetStyle = {
    ...style
  }

  return (
    <div id={id}
      className={cx(className, styles.htmlWidget)}
      style={widgetStyle}
      data-widget-id={id}
    >
      <HtmlView widgetProps={widgetProps} content={widgetProps.content} iframe={iframe} id={id} />
    </div>
  )
}

export const HtmlView = ({ content, iframe, id }) => {

  const [url, setUrl] = React.useState('');
  const html = _.get(content, 'html', `<div></div>`);
  const css = _.get(content, 'css');
  const script = _.get(content, 'script');
  const processedHtml = _.get(content, 'processedHtml');
  const resources = _.get(content, 'resources', []);

  const tags = (resources || []).map((data, id) => {
    if (data.type === 'SCRIPT') {
      return (`<script key='${id}' src='${data.url}' ></script>`)
    } else {
      return (`<link key='${id}' href='${data.url}' rel="stylesheet" ></script>`)
    }
  }).join('');

  const renderCss = () => {
    if (document.getElementById(`style${id}`)) {
      var existingStyle = document.getElementById(`style${id}`);
      existingStyle.textContent = css
      return;
    }
      
    var style = document.createElement('style');
    style.id = `style${id}`
    style.textContent = css
    document.head.appendChild(style);
  }

  const renderJS = () => {

    var jsScript = `try{
      ${script}
    } catch(err){
      console.log(err)
    }`

    if (document.getElementById(`script${id}`)) {
      var existingJs = document.getElementById(`script${id}`);
      existingJs.textContent = jsScript
      return;
    }

    var js = document.createElement('script');
    js.id = `script${id}`
    js.textContent = jsScript
    document.body.appendChild(js)

  }

  useEffect(() => {
    if (processedHtml) {
      setUrl(processedHtml);
    }
  }, []);

  useEffect(() => {
    if (content && !content.processedHtml) {
      processHtml();
    }
  }, [content]);

  useEffect(() => {
    if (css && !iframe) {
      renderCss();
    }
  }, [css])
   
  useEffect(() => {
    if (script && !iframe) {
      renderJS()
    }
  }, [script])

  const renderTag = () => {

    resources?.map((data) => {

      if (data.type === "SCRIPT") {
        var script = document.createElement('script');
        script.src = data.url
        document.body.appendChild(script)
      }
      else {
        var link = document.createElement('link')
        link.href = data.url
        link.rel = 'stylesheet'
        document.head.appendChild(link)
      }


    })
  }
  useEffect(() => {
    if (process.browser) {
      renderTag()
    }
  }, [resources])

  var htmlString = `
  <!DOCTYPE HTML>
  <html lang="en">
      <head>
          <meta charset="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          ${tags}
          <style type="text/css">
              ${css}
          </style>
      </head>
      <body>
          ${html}
          <script th:inline="javascript">
              ${script}
          </script>
      </body>
  </html>`;

  const processHtml = () => {
    var blob = new Blob([htmlString], { type: 'text/html' });
    var newurl = window.URL.createObjectURL(blob);
    setUrl(newurl);
  }

  let isEmpty = !(html && html.trim().length > 0);

  return (
    <React.Fragment>
      {iframe &&
        <iframe width={'100%'} height='100%' className={styles.htmlIframe} src={url}></iframe>
      }

      {!iframe && !isEmpty &&
        <div>
          <InnerHTML html={html} />
        </div>
      }
    </React.Fragment>
  )
}

const htmlWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'content'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const HtmlWidget = React.memo(HtmlWidgetComponent, htmlWidgetEquals);
